import React, { useState } from "react";
import Image from "next/image";
import Router from "next/router";
import { useTranslation } from "next-i18next";
import { useRecoilValue } from "recoil";

import { ShipdaCurrentLanguage } from "@sellernote/shared/src/i18n/i18nForShipda";
import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";
import { FORWARDING_AUTH_ATOMS } from "@sellernote/features/src/forwarding/recoil-states/auth";
import LandingQuickActions from "@sellernote/shipda-kr/src/components/landing/LandingQuickActions";
import LandingSectionServiceIntro from "@sellernote/shipda-kr/src/components/landing/LandingSectionServiceIntro";
import LandingSubSection from "@sellernote/shipda-kr/src/components/landing/LandingSubSection";
import Loading from "@sellernote/ui/src/sds-v1/components/Loading";
import SubmenuVesselIcon from "@sellernote/ui/src/sds-v2/components/svgIcons/SubmenuVesselIcon";

import Layout from "../../containers/Layout";
import Seo from "../../containers/Seo";
import SuspenseWrapper from "../../containers/SuspenseWrapper";
import { getServerSidePropsWithI18n } from "../../utils/i18n";

import {
  RECRUIT_SECTION_DATA,
  SERVICE_INTRO_SECTION_DATA,
  SUB_SECTION_PART1_DATA,
  SUB_SECTION_PART2_DATA,
} from "./DATA";
import LandingSectionCEO from "./LandingSectionCEO";
import LandingSectionYears from "./LandingSectionHistory";
import LandingSectionLogos from "./LandingSectionLogos";
import LandingSectionNumbers from "./LandingSectionNumbers";
import LandingSectionRecruit from "./LandingSectionRecruit";
import LandingSectionValue from "./LandingSectionValue";
import Styled from "./index.styles";

export const getServerSideProps = getServerSidePropsWithI18n();

export default function Company() {
  const { t } = useTranslation(["page-company"]);

  const loggedIn = useRecoilValue(FORWARDING_AUTH_ATOMS.USER_LOGGED_IN);

  const { isMobile } = useCheckIsMobile();

  const [opensRequestGuideFormModal, setOpensRequestGuideFormModal] =
    useState(false);

  const handleRequestGuideFormModalClose = () =>
    setOpensRequestGuideFormModal(false);

  return (
    <Layout size="full">
      <Seo
        path="/company"
        title={
          ShipdaCurrentLanguage.currentLanguage === "ko"
            ? "회사소개 - 디지털 수출입 물류 포워딩 쉽다"
            : "About - ShipDa - Digital freight forwarding service"
        }
        description={
          ShipdaCurrentLanguage.currentLanguage === "ko"
            ? "아날로그 포워딩 업무, 디지털 전환 시작. 디지털 포워딩 서비스 쉽다는 해상운송, 항공운송 수출입 전문 포워더입니다."
            : "Transform analog forwarding into digital. Shipda’s digital Freight forwarding service specialized in freight to/from Korea, Offering ocean FCL/LCL and AIR freight forwarding services."
        }
      />

      <SuspenseWrapper fallback={<Loading active Image={Image} />}>
        <Styled.container>
          <LandingSectionServiceIntro
            {...SERVICE_INTRO_SECTION_DATA}
            badgeList={[t("page-company:인트로섹션_뱃지")]}
            iconInfo={{ Icon: SubmenuVesselIcon }}
            buttonInfo={
              loggedIn
                ? undefined
                : {
                    label: t("page-company:인트로섹션_시작하기_버튼"),
                    onClick: () => Router.push("/register"),
                  }
            }
            opensRequestGuideFormModal={opensRequestGuideFormModal}
            handleRequestGuideFormModalClose={handleRequestGuideFormModalClose}
          />

          <LandingSubSection
            {...SUB_SECTION_PART1_DATA}
            firstSectionBackgroundType="white"
          />

          <LandingSectionNumbers />

          <LandingSectionLogos />

          <LandingSectionYears />

          <LandingSectionValue />

          <LandingSectionCEO {...SUB_SECTION_PART2_DATA} />

          <LandingSectionRecruit
            {...RECRUIT_SECTION_DATA}
            buttonInfo={{
              label: t("page-company:채용섹션_채용중인포지션_버튼"),
              href: "https://bit.ly/recruit_shipda",
            }}
          />

          <LandingQuickActions
            openServiceGuideModal={() => setOpensRequestGuideFormModal(true)}
          />
        </Styled.container>
      </SuspenseWrapper>
    </Layout>
  );
}
